import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/common/services/config.service';
import { HttpInterceptor } from 'src/app/common/services/httpInterceptor.service';
import { RouteHandlerService } from 'src/app/common/services/routeHandler.service';
import { SessionHandlerService } from 'src/app/common/services/sessionHandler.service';
import { CommonConstants } from 'src/app/common/utilities/commonConstants';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})

export class SsoService {

    onValidateSso$: Observable<ActivitiModel.MTResponse<any>>;
    onValidateMO$: Observable<ActivitiModel.MTResponse<any>>;
    cipherKey: string = CommonConstants.SsoConstants.CIPHER_KEY;
    keyInput: string = '9482069544|Satyajeet|Thakare';
    encrypted: string;
    decrypted: string;

    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _sessionHandlerService: SessionHandlerService,
        private _router: Router,
        private _routerService: RouteHandlerService,
        private _http: HttpClient,
    ) { }


    encryptUsingAES256() {
        let _key = CryptoJS.enc.Utf8.parse(this.cipherKey);
        let _iv = CryptoJS.enc.Utf8.parse(this.cipherKey);
        let encrypted = CryptoJS.AES.encrypt(
            JSON.stringify(this.keyInput), _key, {
            keySize: 16,
            iv: _iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return this.encrypted = encrypted.toString();
    }

    decryptUsingAES256() {
        let _key = CryptoJS.enc.Utf8.parse(this.cipherKey);
        let _iv = CryptoJS.enc.Utf8.parse(this.cipherKey);

        return this.decrypted = CryptoJS.AES.decrypt(
            this.encrypted, _key, {
            keySize: 16,
            iv: _iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8);
    }

    public validateSsoToken(payload: any, callback) {
        let url = environment.serviceBaseUrls.DOMAIN01 + CommonConstants.SsoConstants.BusinessServiceLoginURL;
        let headerObj: HttpHeaders;
        headerObj = new HttpHeaders({
        });
        this.onValidateSso$ = this._httpInterceptor.applicationTokensPost(url, payload, headerObj, false);
        this.onValidateSso$.subscribe(resp => {
            callback('success', resp);
        }, (error) => {
            callback('error', null);
        });
    }


    public getPrefilledUserData(payload: any) {
        let url = environment.serviceBaseUrls.DOMAIN01 + CommonConstants.SsoConstants.CUSTOMER_DEDUPE_API;
        const headerObj: HttpHeaders = new HttpHeaders({
            "Content-Type": "application/json",
            "authtoken": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken)
        });
        const options = { headers: headerObj };
        return this._http.post(url, payload, options);
    }

    public GetSystemAuthToken(requestData: any): Observable<ActivitiModel.MTResponse<any>> {
        const customHeaders = {
            platform: this.getDevicePlatformType()
        };
        return this._httpInterceptor.Post(this.getUrlBasedOnKey('getTokenForUser'),
            requestData, true);
    }

    private getDevicePlatformType(): string {
        const cookieData = this._sessionHandlerService
            .GetSession(CommonConstants.CookieKeys.DeviceDetails);
        if (cookieData && cookieData !== '') {
            const deviceDetails: DeviceDetails = JSON.parse(cookieData);
            return deviceDetails.mobile ? 'mob' : 'desk'; // desk, mob, moba
        } else {
            return 'desk';
        }
    }
    private getUrlBasedOnKey(key: string): string {
        ConfigService.getInstance().getConfigData();
        return ConfigService.getInstance().getConfigObject().APIURL[key];
    }

    public moTokenValidationAPI(payload: any) {
        let url = environment.serviceBaseUrls.DOMAIN01 + CommonConstants.SsoConstants.MOTOKEN_VALIDATION_API;
        let headerObj: HttpHeaders;
        headerObj = new HttpHeaders({
        });
        return this._httpInterceptor.applicationTokensPost(url, payload, headerObj, false);
    }
}